<template>
    <div id="inquirydocumentsadmin">
        <nav>
            <div class="leftNav">
                <div class="innerNav">
                    <img class="navLogout" v-on:click="openNav()" src="/assets/burger.png" alt="burger" />
                </div>
            </div>
            <center>
                <img class="main" v-on:click="reload()" src="/assets/logo.png" alt="SO" />
            </center>
            <div class="rightNav">
                <div class="innerNav">
                    <span class="pNav">
                        {{Name}}
                    </span>
                    <img class="logoNav" src="/assets/adpr.png" alt="ADPR" />
                </div>
            </div>
            <div class="sideNav" :style="{ width: navWidth + 'px' }">
                <div class="leftNav">
                    <div class="innerNav">
                        <img class="navLogout" v-on:click="openNav()" src="/assets/burgerwhite.png" alt="burger" />
                    </div>
                </div>
                <div v-if="navMenuVisible" class="navsidecontent">
                    <div class="navtitle noborder">
                        Gérer les biens et demandes
                    </div>
                    <div v-on:click="goToNewBuildingPage" class="navsubtitle">
                        Créer un nouveau bien
                    </div>
                    <div v-on:click="goToBuildingPage" class="navsubtitle">
                        Consulter/Modifier les biens et demandes
                    </div>
                    <div class="navtitle">
                        Plannings
                    </div>
                    <div v-on:click="goToPlanningPage" class="navsubtitle">
                        Consulter/Modifier les plannings
                    </div>
                    <div v-on:click="goToTimeSheetPage" class="navsubtitle">
                        Fiches horaires
                    </div>
                    <div class="navtitle">
                        Groupes
                    </div>
                    <div v-on:click="goToNewGroupPage" class="navsubtitle">
                        Ajouter un groupe
                    </div>
                    <div v-on:click="goToAllGroupPage" class="navsubtitle">
                        Voir/Modifier les groupes
                    </div>
                    <div class="navtitle">
                        Utilisateurs
                    </div>
                    <div v-on:click="goToNewUserPage" class="navsubtitle">
                        Ajouter un utilisateur
                    </div>
                    <div v-on:click="goToAllUserPage" class="navsubtitle">
                        Voir/Modifier les utilisateurs
                    </div>
                    <div v-on:click="logout()" class="navtitle logout">
                        Déconnexion
                    </div>
                </div>
            </div>
        </nav>
        <div v-if="loading" id="loading">
            <img style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);" src="/assets/ajaxloader.gif" id="loading-image" alt="Loading..." />
        </div>
        <div class="filAriane">
            <span v-html="filAriane"></span>
        </div>
        <div class="outercircle">
            <div class="homeName">
                {{Name}}
            </div>
            <div id="circle"></div>
        </div>
        <h1>
            <button v-on:click="backbtn()" class="btnBack">
                <font-awesome-icon icon="arrow-alt-circle-left" />
            </button>
            {{inquiry.name}} &nbsp;&nbsp;-&nbsp;&nbsp; {{inquiry.status}}
        </h1>
        <div class="greyBack">
            <div class="title"><b>{{inquiry.type}}</b></div>
            <div class="img">
                <div v-if="inquiry.document.length || inquiry.TVAsheet || inquiry.gazsheet || inquiry.fioulsheet || inquiry.climsheet">
                    <div v-if="inquiry.document.length">
                        <div v-for="(item, index) in inquiry.document" :key="index" class="allImg">
                            <div v-on:click="chageModalState(index)" class="oneImg"><img data-lightbox="example-set" src="/assets/pdf.png" alt="PDF" /><span>{{pdfTitle[index]}}</span></div>
                            <div id="myModal" v-on:click="chageModalState(index)"  v-bind:class="[isActive[index] ? 'modalActive' : 'modalInactive']">
                                <span class="close">&times;</span>
                                <a :href="pdfLink[index]" :download="pdfLink[index]" class="dlBtn">Télécharger {{pdfTitle[index]}}</a><br><br>
                                <pdf class="pdfViewer modal-content" v-on:click.stop="" v-for="i in numPages[index]" :key="i" :src="pdfLink[index]" :page="i"></pdf>
                            </div>
                        </div>
                    </div>
                    <div v-if="inquiry.TVAsheet" class="allImg">
                        <!-- <div v-on:click="chageModalState(0+inquiry.document.length)" class="oneImg"><img data-lightbox="example-set" src="/assets/pdf.png" alt="PDF" /><span>{{pdfTitle[0+inquiry.document.length]}}</span></div> -->
                        <div v-on:click="goToCerfaTVADetail()" class="oneImg"><img data-lightbox="example-set" src="/assets/pdf.png" alt="PDF" /><span>{{pdfTitle[0+inquiry.document.length]}}</span></div>
                        <div id="myModal" v-on:click="chageModalState(0+inquiry.document.length)"  v-bind:class="[isActive[0+inquiry.document.length] ? 'modalActive' : 'modalInactive']">
                            <span class="close">&times;</span>
                            <a :href="pdfLink[0+inquiry.document.length]" :download="pdfLink[0+inquiry.document.length]" class="dlBtn">Télécharger {{pdfTitle[0+inquiry.document.length]}}</a><br><br>
                            <pdf class="pdfViewer modal-content" v-on:click.stop="" v-for="i in numPages[0+inquiry.document.length]" :key="i" :src="pdfLink[0+inquiry.document.length]" :page="i"></pdf>
                        </div>
                    </div>
                    <div v-if="inquiry.gazsheet" class="allImg">
                        <!-- <div v-on:click="chageModalState(indexGAZ+inquiry.document.length)" class="oneImg"><img data-lightbox="example-set" src="/assets/pdf.png" alt="PDF" /><span>{{pdfTitle[indexGAZ+inquiry.document.length]}}</span></div> -->
                        <div v-on:click="goToCerfaGAZDetail()" class="oneImg"><img data-lightbox="example-set" src="/assets/pdf.png" alt="PDF" /><span>{{pdfTitle[indexGAZ+inquiry.document.length]}}</span></div>
                        <div id="myModal" v-on:click="chageModalState(indexGAZ+inquiry.document.length)"  v-bind:class="[isActive[indexGAZ+inquiry.document.length] ? 'modalActive' : 'modalInactive']">
                            <span class="close">&times;</span>
                            <a :href="pdfLink[indexGAZ+inquiry.document.length]" :download="pdfLink[indexGAZ+inquiry.document.length]" class="dlBtn">Télécharger {{pdfTitle[indexGAZ+inquiry.document.length]}}</a><br><br>
                            <pdf class="pdfViewer modal-content" v-on:click.stop="" v-for="i in numPages[indexGAZ+inquiry.document.length]" :key="i" :src="pdfLink[indexGAZ+inquiry.document.length]" :page="i"></pdf>
                        </div>
                    </div>
                    <div v-if="inquiry.fioulsheet" class="allImg">
                        <!-- <div v-on:click="chageModalState(indexFIOUL+inquiry.document.length)" class="oneImg"><img data-lightbox="example-set" src="/assets/pdf.png" alt="PDF" /><span>{{pdfTitle[indexFIOUL+inquiry.document.length]}}</span></div> -->
                        <div v-on:click="goToCerfaFIOULDetail()" class="oneImg"><img data-lightbox="example-set" src="/assets/pdf.png" alt="PDF" /><span>{{pdfTitle[indexFIOUL+inquiry.document.length]}}</span></div>
                        <div id="myModal" v-on:click="chageModalState(indexFIOUL+inquiry.document.length)"  v-bind:class="[isActive[indexFIOUL+inquiry.document.length] ? 'modalActive' : 'modalInactive']">
                            <span class="close">&times;</span>
                            <a :href="pdfLink[indexFIOUL+inquiry.document.length]" :download="pdfLink[indexFIOUL+inquiry.document.length]" class="dlBtn">Télécharger {{pdfTitle[indexFIOUL+inquiry.document.length]}}</a><br><br>
                                
                            <div class="pdfcontainer">    
                                <pdf class="pdfViewer modal-content" v-on:click.stop="" v-for="i in numPages[indexFIOUL+inquiry.document.length]" :key="i" :src="pdfLink[indexFIOUL+inquiry.document.length]" :page="i"></pdf>
                        
                                   <!-- commanditaire -->
                                <input class="nameOverPdf fix-focus" v-model="cerfaFIOUL.customerAddress.lastName" />
                                <input class="customerFirstname fix-focus" v-model="cerfaFIOUL.customerAddress.firstName" />
                                <input class="customerStreetName fix-focus" v-model="cerfaFIOUL.customerAddress.streetName" />
                                <!-- enterprise -->
                                <input class="companyName fix-focus" v-model="cerfaFIOUL.company.company" />
                                <input class="companyPhone fix-focus" v-model="cerfaFIOUL.company.phoneNumber" />
                                <input class="companyAdress fix-focus" v-model="cerfaFIOUL.company.streetName" />
                                <!-- water heater info -->
                                <input class="waterHeaterBrand fix-focus" v-model="cerfaFIOUL.waterHeater.brand" />
                                <input class="waterHeaterPower fix-focus" v-model="cerfaFIOUL.waterHeater.power" />
                                <input class="waterHeaterEvacuationType fix-focus" v-model="cerfaFIOUL.waterHeater.evacuationType" />
                                <input class="waterHeaterPutIntoUse fix-focus" v-model="cerfaFIOUL.waterHeater.putIntoUse" />
                                <input class="waterHeaterSerialNumber fix-focus" v-model="cerfaFIOUL.waterHeater.serialNumber" />
                                <!-- burner info   -->
                                <input class="burnerBrand fix-focus" v-model="cerfaFIOUL.burner.brand" />
                                <input class="burnerPower fix-focus" v-model="cerfaFIOUL.burner.power" />
                                <input class="burnerEvacuationType fix-focus" v-model="cerfaFIOUL.burner.evacuationType" />
                                <input class="burnerPutIntoUse fix-focus" v-model="cerfaFIOUL.burner.putIntoUse" />
                                <input class="burnerSerialNumber fix-focus" v-model="cerfaFIOUL.burner.serialNumber" />
                                <input class="lastIntervention fix-focus " v-model="cerfaFIOUL.lastIntervention" />
                                <input class="lastCleaningIntervention fix-focus" v-model="cerfaFIOUL.lastCleaningIntervention" />
                                <!-- mandatory checks -->
                                <div class="accept deviceConnectionOk">
                                    <input class="fix-focus" type="checkbox" id="deviceConnectionOk" value="Validé" v-model="cerfaFIOUL.deviceConnection" />
                                    <label for="deviceConnectionOk"></label>
                                </div>
                                <div class="accept deviceConnectionNOT">
                                    <input class="fix-focus" type="checkbox" id="deviceConnectionNOT" value="Non Validé" v-model="cerfaFIOUL.deviceConnection" />
                                    <label for="deviceConnectionNOT"></label>
                                </div>
                                <!-- 2 -->
                                <div class="accept burnerCorsCleaningOK">
                                    <input class="fix-focus" type="checkbox" id="burnerCorsCleaningOK" value="Validé" v-model="cerfaFIOUL.burnerCorsCleaning" />
                                    <label for="burnerCorsCleaningOK"></label>
                                </div>
                                <div class="accept burnerCorsCleaningNOT">
                                    <input class="fix-focus" type="checkbox" id="burnerCorsCleaningNOT" value="Non Validé" v-model="cerfaFIOUL.burnerCorsCleaning" />
                                    <label for="burnerCorsCleaningNOT"></label>
                                </div>
                                <!-- 3 -->
                                <div class="accept burnerCleaningOk">
                                    <input class="fix-focus" type="checkbox" id="burnerCleaningOk" value="Validé" v-model="cerfaFIOUL.burnerCleaning" />
                                    <label for="burnerCleaningOk"></label>
                                </div>
                                <div class="accept burnerCleaningNOT">
                                    <input class="fix-focus" type="checkbox" id="burnerCleaningNOT" value="Non Validé" v-model="cerfaFIOUL.burnerCleaning" />
                                    <label for="burnerCleaningNOT"></label>
                                </div>
                                <!-- 4 -->
                                <div class="accept preFilterFioulCleaningOk">
                                    <input class="fix-focus" type="checkbox" id="preFilterFioulCleaningOk" value="Validé" v-model="cerfaFIOUL.preFilterFioulCleaning" />
                                    <label for="preFilterFioulCleaningOk"></label>
                                </div>
                                <div class="accept preFilterFioulCleaningNOT">
                                    <input class="fix-focus" type="checkbox" id="preFilterFioulCleaningNOT" value="Non Validé" v-model="cerfaFIOUL.preFilterFioulCleaning" />
                                    <label for="preFilterFioulCleaningNOT"></label>
                                </div>
                                <div class="accept preFilterFioulCleaningOther">
                                    <input class="fix-focus" type="checkbox" id="preFilterFioulCleaningOther" value="Sans objet" v-model="cerfaFIOUL.preFilterFioulCleaning" />
                                    <label for="preFilterFioulCleaningOther"></label>
                                </div>

                                <!-- 5 -->
                                <div class="accept fioulFilterCleaningOk">
                                    <input class="fix-focus" type="checkbox" id="fioulFilterCleaningOk" value="Validé" v-model="cerfaFIOUL.fioulFilterCleaning" />
                                    <label for="fioulFilterCleaningOk"></label>
                                </div>
                                <div class="accept fioulFilterCleaningNOT">
                                    <input class="fix-focus" type="checkbox" id="fioulFilterCleaningNOT" value="Non Validé" v-model="cerfaFIOUL.fioulFilterCleaning" />
                                    <label for="fioulFilterCleaningNOT"></label>
                                </div>
                                <!-- 6 -->
                                <div class="accept deviceSecurityCheckOk">
                                    <input class="fix-focus" type="checkbox" id="deviceSecurityCheckOk" value="Validé" v-model="cerfaFIOUL.deviceSecurityCheck" />
                                    <label for="deviceSecurityCheckOk"></label>
                                </div>
                                <div class="accept deviceSecurityCheckNOT">
                                    <input class="fix-focus" type="checkbox" id="deviceSecurityCheckNOT" value="Non Validé" v-model="cerfaFIOUL.deviceSecurityCheck" />
                                    <label for="deviceSecurityCheckNOT"></label>
                                </div>
                                <!-- 7 -->
                                <div class="accept devicHeatingCirculatorCheckOk">
                                    <input class="fix-focus" type="checkbox" id="devicHeatingCirculatorCheckOk" value="Validé" v-model="cerfaFIOUL.devicHeatingCirculatorCheck" />
                                    <label for="devicHeatingCirculatorCheckOk"></label>
                                </div>
                                <div class="accept devicHeatingCirculatorCheckNOT">
                                    <input class="fix-focus" type="checkbox" id="devicHeatingCirculatorCheckNOT" value="Non Validé" v-model="cerfaFIOUL.devicHeatingCirculatorCheck" />
                                    <label for="devicHeatingCirculatorCheckNOT"></label>
                                </div>
                                <div class="accept devicHeatingCirculatorCheckOther">
                                    <input class="fix-focus" type="checkbox" id="devicHeatingCirculatorCheckOther" value="Sans objet" v-model="cerfaFIOUL.devicHeatingCirculatorCheck" />
                                    <label for="devicHeatingCirculatorCheckOther"></label>
                                </div>
                                <!-- recommended checks -->
                                <div class="accept deviceRegilationComponentsCheckOk">
                                    <input class="fix-focus" type="checkbox" id="deviceRegilationComponentsCheckOk" value="Validé" v-model="cerfaFIOUL.deviceRegilationComponentsCheck" />
                                    <label for="deviceRegilationComponentsCheckOk"></label>
                                </div>
                                <div class="accept deviceRegilationComponentsCheckNOT">
                                    <input class="fix-focus" type="checkbox" id="deviceRegilationComponentsCheckNOT" value="Non Validé" v-model="cerfaFIOUL.deviceRegilationComponentsCheck" />
                                    <label for="deviceRegilationComponentsCheckNOT"></label>
                                </div>
                                <div class="accept deviceRegilationComponentsCheckOther">
                                    <input class="fix-focus" type="checkbox" id="deviceRegilationComponentsCheckOther" value="Sans objet" v-model="cerfaFIOUL.deviceRegilationComponentsCheck" />
                                    <label for="deviceRegilationComponentsCheckOther"></label>
                                </div>

                                <div class="accept deviceHydrauliquePressureCheckOk">
                                    <input class="fix-focus" type="checkbox" id="deviceHydrauliquePressureCheckOk" value="Validé" v-model="cerfaFIOUL.deviceHydrauliquePressureCheck" />
                                    <label for="deviceHydrauliquePressureCheckOk"></label>
                                </div>
                                <div class="accept deviceHydrauliquePressureCheckNOT">
                                    <input class="fix-focus" type="checkbox" id="deviceHydrauliquePressureCheckNOT" value="Non Validé" v-model="cerfaFIOUL.deviceHydrauliquePressureCheck" />
                                    <label for="deviceHydrauliquePressureCheckNOT"></label>
                                </div>

                                <div class="accept deviceAnodeAndAccessoriesCheckOk">
                                    <input class="fix-focus" type="checkbox" id="deviceAnodeAndAccessoriesCheckOk" value="Validé" v-model="cerfaFIOUL.deviceAnodeAndAccessoriesCheck" />
                                    <label for="deviceAnodeAndAccessoriesCheckOk"></label>
                                </div>
                                <div class="accept deviceAnodeAndAccessoriesCheckNOT">
                                    <input class="fix-focus" type="checkbox" id="deviceAnodeAndAccessoriesCheckNOT" value="Non Validé" v-model="cerfaFIOUL.deviceAnodeAndAccessoriesCheck" />
                                    <label for="deviceAnodeAndAccessoriesCheckNOT"></label>
                                </div>
                                <div class="accept deviceAnodeAndAccessoriesCheckOther">
                                    <input class="fix-focus" type="checkbox" id="deviceAnodeAndAccessoriesCheckOther" value="Sans objet" v-model="cerfaFIOUL.deviceAnodeAndAccessoriesCheck" />
                                    <label for="deviceAnodeAndAccessoriesCheckOther"></label>
                                </div>

                                <textarea class="otherCheckedPoints fix-focus" rows="2" v-model="cerfaFIOUL.otherCheckedPoints" />
                                <!-- added tests -->
                                <input class="bacharachTest fix-focus" v-model="cerfaFIOUL.deviceMesures.bacharachTest" />
                                <input class="smokeTemperature fix-focus" v-model="cerfaFIOUL.deviceMesures.smokeTemperature" />
                                <input class="ambianteTemperature fix-focus" v-model="cerfaFIOUL.deviceMesures.ambianteTemperature" />
                                <input class="smokeContent fix-focus" v-model="cerfaFIOUL.deviceMesures.smokeContent" />
                                <input class="pressure fix-focus" v-model="cerfaFIOUL.deviceMesures.pressure" />
                                <!-- teneur en CO -->
                                <input class="contentCO fix-focus" v-model="cerfaFIOUL.deviceMesures.contentCO" />

                                <div class="accept contentCOPercentageOk">
                                    <input class="fix-focus" type="checkbox" id="contentCOPercentageOk" value="Validé" v-model="cerfaFIOUL.contentCOPercentage" />
                                    <label for="contentCOPercentageOk"></label>
                                </div>
                                <div class="accept contentCOPercentageNOT">
                                    <input class="fix-focus" type="checkbox" id="contentCOPercentageNOT" value="Non Validé" v-model="cerfaFIOUL.contentCOPercentage" />
                                    <label for="contentCOPercentageNOT"></label>
                                </div>
                                <div class="accept contentCOPercentageDanger">
                                    <input class="fix-focus" type="checkbox" id="contentCOPercentageDanger" value="Sans objet" v-model="cerfaFIOUL.contentCOPercentage" />
                                    <label for="contentCOPercentageDanger"></label>
                                </div>
                                <!--  -->
                                <input class="mesurementDevice fix-focus" v-model="cerfaFIOUL.mesurementDevice" />
                                <!-- performance -->
                                <input class="mesuredPerformance fix-focus" v-model="cerfaFIOUL.heaterPerformance.mesuredPerformance" />
                                <input class="referencedPerformance fix-focus" v-model="cerfaFIOUL.heaterPerformance.referencedPerformance" />
                                <input class="NOxEmission fix-focus" v-model="cerfaFIOUL.heaterPerformance.NOxEmission" />
                                <!-- remarks -->
                                <textarea class="correctedDefect fix-focus" rows="6" v-model="cerfaFIOUL.correctedDefect" />
                                <textarea class="usageRecommendation fix-focus" rows="9" v-model="cerfaFIOUL.usageRecommendation" />
                                <textarea class="upgradeRecommendation fix-focus" rows="9" v-model="cerfaFIOUL.upgradeRecommendation" />
                                <textarea class="futureRecommendation fix-focus" rows="7" v-model="cerfaFIOUL.futureRecommendation" />
                                <input class="signatureTimestamp fix-focus" v-model="cerfaFIOUL.signatureTimestamp" />
                                <img :src="sig" class="imgOverPdf" />
                                <img :src="sig2" class="imgOverPdf2" />
                            </div>                        
                        </div>
                    </div>
                    <div v-if="inquiry.climsheet" class="allImg">
                        <!-- <div v-on:click="chageModalState(indexCLIM+inquiry.document.length)" class="oneImg"><img data-lightbox="example-set" src="/assets/pdf.png" alt="PDF" /><span>{{pdfTitle[indexCLIM+inquiry.document.length]}}</span></div> -->
                        <div v-on:click="goToCerfaCLIMDetail()" class="oneImg"><img data-lightbox="example-set" src="/assets/pdf.png" alt="PDF" /><span>{{pdfTitle[indexCLIM+inquiry.document.length]}}</span></div>
                        <div id="myModal" v-on:click="chageModalState(indexCLIM+inquiry.document.length)"  v-bind:class="[isActive[indexCLIM+inquiry.document.length] ? 'modalActive' : 'modalInactive']">
                            <span class="close">&times;</span>
                            <a :href="pdfLink[indexCLIM+inquiry.document.length]" :download="pdfLink[indexCLIM+inquiry.document.length]" class="dlBtn">Télécharger {{pdfTitle[indexCLIM+inquiry.document.length]}}</a><br><br>
                            <div class="pdfcontainer">
                                <pdf class="pdfViewer modal-content" v-on:click.stop="" v-for="i in numPages[indexCLIM+inquiry.document.length]" :key="i" :src="pdfLink[indexCLIM+inquiry.document.length]" :page="i"></pdf>

                                   <!-- commanditaire -->
                                <input class="nameOverPdf fix-focus" v-model="cerfaFIOUL.customerAddress.lastName" />
                                <input class="customerFirstname fix-focus" v-model="cerfaFIOUL.customerAddress.firstName" />
                                <input class="customerStreetName fix-focus" v-model="cerfaFIOUL.customerAddress.streetName" />
                                <!-- enterprise -->
                                <input class="companyName fix-focus" v-model="cerfaFIOUL.company.company" />
                                <input class="companyPhone fix-focus" v-model="cerfaFIOUL.company.phoneNumber" />
                                <input class="companyAdress fix-focus" v-model="cerfaFIOUL.company.streetName" />
                                <!-- water heater info -->
                                <input class="waterHeaterBrand fix-focus" v-model="cerfaFIOUL.waterHeater.brand" />
                                <input class="waterHeaterPower fix-focus" v-model="cerfaFIOUL.waterHeater.power" />
                                <input class="waterHeaterEvacuationType fix-focus" v-model="cerfaFIOUL.waterHeater.evacuationType" />
                                <input class="waterHeaterPutIntoUse fix-focus" v-model="cerfaFIOUL.waterHeater.putIntoUse" />
                                <input class="waterHeaterSerialNumber fix-focus" v-model="cerfaFIOUL.waterHeater.serialNumber" />
                                <!-- burner info   -->
                                <input class="burnerBrand fix-focus" v-model="cerfaFIOUL.burner.brand" />
                                <input class="burnerPower fix-focus" v-model="cerfaFIOUL.burner.power" />
                                <input class="burnerEvacuationType fix-focus" v-model="cerfaFIOUL.burner.evacuationType" />
                                <input class="burnerPutIntoUse fix-focus" v-model="cerfaFIOUL.burner.putIntoUse" />
                                <input class="burnerSerialNumber fix-focus" v-model="cerfaFIOUL.burner.serialNumber" />
                                <input class="lastIntervention fix-focus" v-model="cerfaFIOUL.lastIntervention" />
                                <input class="lastCleaningIntervention fix-focus" v-model="cerfaFIOUL.lastCleaningIntervention" />
                                <!-- mandatory checks -->
                                <div class="accept deviceConnectionOk">
                                    <input class="fix-focus" type="checkbox" id="deviceConnectionOk" value="Validé" v-model="cerfaFIOUL.deviceConnection" />
                                    <label for="deviceConnectionOk"></label>
                                </div>
                                <div class="accept deviceConnectionNOT">
                                    <input class="fix-focus" type="checkbox" id="deviceConnectionNOT" value="Non Validé" v-model="cerfaFIOUL.deviceConnection" />
                                    <label for="deviceConnectionNOT"></label>
                                </div>
                                <!-- 2 -->
                                <div class="accept burnerCorsCleaningOK">
                                    <input class="fix-focus" type="checkbox" id="burnerCorsCleaningOK" value="Validé" v-model="cerfaFIOUL.burnerCorsCleaning" />
                                    <label for="burnerCorsCleaningOK"></label>
                                </div>
                                <div class="accept burnerCorsCleaningNOT">
                                    <input class="fix-focus" type="checkbox" id="burnerCorsCleaningNOT" value="Non Validé" v-model="cerfaFIOUL.burnerCorsCleaning" />
                                    <label for="burnerCorsCleaningNOT"></label>
                                </div>
                                <!-- 3 -->
                                <div class="accept burnerCleaningOk">
                                    <input class="fix-focus" type="checkbox" id="burnerCleaningOk" value="Validé" v-model="cerfaFIOUL.burnerCleaning" />
                                    <label for="burnerCleaningOk"></label>
                                </div>
                                <div class="accept burnerCleaningNOT">
                                    <input class="fix-focus" type="checkbox" id="burnerCleaningNOT" value="Non Validé" v-model="cerfaFIOUL.burnerCleaning" />
                                    <label for="burnerCleaningNOT"></label>
                                </div>
                                <!-- 4 -->
                                <div class="accept preFilterFioulCleaningOk">
                                    <input class="fix-focus" type="checkbox" id="preFilterFioulCleaningOk" value="Validé" v-model="cerfaFIOUL.preFilterFioulCleaning" />
                                    <label for="preFilterFioulCleaningOk"></label>
                                </div>
                                <div class="accept preFilterFioulCleaningNOT">
                                    <input class="fix-focus" type="checkbox" id="preFilterFioulCleaningNOT" value="Non Validé" v-model="cerfaFIOUL.preFilterFioulCleaning" />
                                    <label for="preFilterFioulCleaningNOT"></label>
                                </div>
                                <div class="accept preFilterFioulCleaningOther">
                                    <input class="fix-focus" type="checkbox" id="preFilterFioulCleaningOther" value="Sans objet" v-model="cerfaFIOUL.preFilterFioulCleaning" />
                                    <label for="preFilterFioulCleaningOther"></label>
                                </div>

                                <!-- 5 -->
                                <div class="accept fioulFilterCleaningOk">
                                    <input class="fix-focus" type="checkbox" id="fioulFilterCleaningOk" value="Validé" v-model="cerfaFIOUL.fioulFilterCleaning" />
                                    <label for="fioulFilterCleaningOk"></label>
                                </div>
                                <div class="accept fioulFilterCleaningNOT">
                                    <input class="fix-focus" type="checkbox" id="fioulFilterCleaningNOT" value="Non Validé" v-model="cerfaFIOUL.fioulFilterCleaning" />
                                    <label for="fioulFilterCleaningNOT"></label>
                                </div>
                                <!-- 6 -->
                                <div class="accept deviceSecurityCheckOk">
                                    <input class="fix-focus" type="checkbox" id="deviceSecurityCheckOk" value="Validé" v-model="cerfaFIOUL.deviceSecurityCheck" />
                                    <label for="deviceSecurityCheckOk"></label>
                                </div>
                                <div class="accept deviceSecurityCheckNOT">
                                    <input class="fix-focus" type="checkbox" id="deviceSecurityCheckNOT" value="Non Validé" v-model="cerfaFIOUL.deviceSecurityCheck" />
                                    <label for="deviceSecurityCheckNOT"></label>
                                </div>
                                <!-- 7 -->
                                <div class="accept devicHeatingCirculatorCheckOk">
                                    <input class="fix-focus" type="checkbox" id="devicHeatingCirculatorCheckOk" value="Validé" v-model="cerfaFIOUL.devicHeatingCirculatorCheck" />
                                    <label for="devicHeatingCirculatorCheckOk"></label>
                                </div>
                                <div class="accept devicHeatingCirculatorCheckNOT">
                                    <input class="fix-focus" type="checkbox" id="devicHeatingCirculatorCheckNOT" value="Non Validé" v-model="cerfaFIOUL.devicHeatingCirculatorCheck" />
                                    <label for="devicHeatingCirculatorCheckNOT"></label>
                                </div>
                                <div class="accept devicHeatingCirculatorCheckOther">
                                    <input class="fix-focus" type="checkbox" id="devicHeatingCirculatorCheckOther" value="Sans objet" v-model="cerfaFIOUL.devicHeatingCirculatorCheck" />
                                    <label for="devicHeatingCirculatorCheckOther"></label>
                                </div>
                                <!-- recommended checks -->
                                <div class="accept deviceRegilationComponentsCheckOk">
                                    <input class="fix-focus" type="checkbox" id="deviceRegilationComponentsCheckOk" value="Validé" v-model="cerfaFIOUL.deviceRegilationComponentsCheck" />
                                    <label for="deviceRegilationComponentsCheckOk"></label>
                                </div>
                                <div class="accept deviceRegilationComponentsCheckNOT">
                                    <input class="fix-focus" type="checkbox" id="deviceRegilationComponentsCheckNOT" value="Non Validé" v-model="cerfaFIOUL.deviceRegilationComponentsCheck" />
                                    <label for="deviceRegilationComponentsCheckNOT"></label>
                                </div>
                                <div class="accept deviceRegilationComponentsCheckOther">
                                    <input class="fix-focus" type="checkbox" id="deviceRegilationComponentsCheckOther" value="Sans objet" v-model="cerfaFIOUL.deviceRegilationComponentsCheck" />
                                    <label for="deviceRegilationComponentsCheckOther"></label>
                                </div>

                                <div class="accept deviceHydrauliquePressureCheckOk">
                                    <input class="fix-focus" type="checkbox" id="deviceHydrauliquePressureCheckOk" value="Validé" v-model="cerfaFIOUL.deviceHydrauliquePressureCheck" />
                                    <label for="deviceHydrauliquePressureCheckOk"></label>
                                </div>
                                <div class="accept deviceHydrauliquePressureCheckNOT">
                                    <input class="fix-focus" type="checkbox" id="deviceHydrauliquePressureCheckNOT" value="Non Validé" v-model="cerfaFIOUL.deviceHydrauliquePressureCheck" />
                                    <label for="deviceHydrauliquePressureCheckNOT"></label>
                                </div>

                                <div class="accept deviceAnodeAndAccessoriesCheckOk">
                                    <input class="fix-focus" type="checkbox" id="deviceAnodeAndAccessoriesCheckOk" value="Validé" v-model="cerfaFIOUL.deviceAnodeAndAccessoriesCheck" />
                                    <label for="deviceAnodeAndAccessoriesCheckOk"></label>
                                </div>
                                <div class="accept deviceAnodeAndAccessoriesCheckNOT">
                                    <input class="fix-focus" type="checkbox" id="deviceAnodeAndAccessoriesCheckNOT" value="Non Validé" v-model="cerfaFIOUL.deviceAnodeAndAccessoriesCheck" />
                                    <label for="deviceAnodeAndAccessoriesCheckNOT"></label>
                                </div>
                                <div class="accept deviceAnodeAndAccessoriesCheckOther">
                                    <input class="fix-focus" type="checkbox" id="deviceAnodeAndAccessoriesCheckOther" value="Sans objet" v-model="cerfaFIOUL.deviceAnodeAndAccessoriesCheck" />
                                    <label for="deviceAnodeAndAccessoriesCheckOther"></label>
                                </div>

                                <textarea class="otherCheckedPoints fix-focus" rows="2" v-model="cerfaFIOUL.otherCheckedPoints" />
                                <!-- added tests -->
                                <input class="bacharachTest fix-focus" v-model="cerfaFIOUL.deviceMesures.bacharachTest" />
                                <input class="smokeTemperature fix-focus" v-model="cerfaFIOUL.deviceMesures.smokeTemperature" />
                                <input class="ambianteTemperature fix-focus" v-model="cerfaFIOUL.deviceMesures.ambianteTemperature" />
                                <input class="smokeContent fix-focus" v-model="cerfaFIOUL.deviceMesures.smokeContent" />
                                <input class="pressure fix-focus" v-model="cerfaFIOUL.deviceMesures.pressure" />
                                <!-- teneur en CO -->
                                <input class="contentCO fix-focus" v-model="cerfaFIOUL.deviceMesures.contentCO" />

                                <div class="accept contentCOPercentageOk">
                                    <input class="fix-focus" type="checkbox" id="contentCOPercentageOk" value="Validé" v-model="cerfaFIOUL.contentCOPercentage" />
                                    <label for="contentCOPercentageOk"></label>
                                </div>
                                <div class="accept contentCOPercentageNOT">
                                    <input class="fix-focus" type="checkbox" id="contentCOPercentageNOT" value="Non Validé" v-model="cerfaFIOUL.contentCOPercentage" />
                                    <label for="contentCOPercentageNOT"></label>
                                </div>
                                <div class="accept contentCOPercentageDanger">
                                    <input class="fix-focus" type="checkbox" id="contentCOPercentageDanger" value="Sans objet" v-model="cerfaFIOUL.contentCOPercentage" />
                                    <label for="contentCOPercentageDanger"></label>
                                </div>
                                <!--  -->
                                <input class="mesurementDevice fix-focus" v-model="cerfaFIOUL.mesurementDevice" />
                                <!-- performance -->
                                <input class="mesuredPerformance fix-focus" v-model="cerfaFIOUL.heaterPerformance.mesuredPerformance" />
                                <input class="referencedPerformance fix-focus" v-model="cerfaFIOUL.heaterPerformance.referencedPerformance" />
                                <input class="NOxEmission fix-focus" v-model="cerfaFIOUL.heaterPerformance.NOxEmission" />
                                <!-- remarks -->
                                <textarea class="correctedDefect fix-focus" rows="6" v-model="cerfaFIOUL.correctedDefect" />
                                <textarea class="usageRecommendation fix-focus" rows="9" v-model="cerfaFIOUL.usageRecommendation" />
                                <textarea class="upgradeRecommendation fix-focus" rows="9" v-model="cerfaFIOUL.upgradeRecommendation" />
                                <textarea class="futureRecommendation fix-focus" rows="7" v-model="cerfaFIOUL.futureRecommendation" />
                                <input class="signatureTimestamp fix-focus" v-model="cerfaFIOUL.signatureTimestamp" />
                                <img :src="sig" class="imgOverPdf" />
                                <img :src="sig2" class="imgOverPdf2" />
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    Aucun documents
                </div>
            </div>
            <div class="divCard">
                <input  type="file" ref="file" @change="onDocumentSelected" style="display: none">
                <button class="btnNewBtn" @click="$refs.file.click()"><font-awesome-icon icon="plus" /></button>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import pdf from 'vue-pdf';

    export default {
        name: 'inquirydocumentsadmin',
        components: {
            pdf
        },
        data() {
            return {
                inquiry : {},
                cerfaTVA : {},
                cerfaCLIM : {},
                cerfaGAZ : {},
                cerfaFIOUL : {},
                indexCLIM:0,
                indexFIOUL:0,
                indexGAZ:0,
                Name:"client",
                date: "01/01/2019",
                sigTVA: "/assets/nosignature.png",
                sigCLIM: "/assets/nosignature.png",
                sigGAZ: "/assets/nosignature.png",
                sigFIOUL: "/assets/nosignature.png",
                sigGAZ2: "/assets/nosignature.png",
                sigFIOUL2: "/assets/nosignature.png",
                files: [],
                pdfTitle: [],
                pdfLink: [],
                numPages:[],
                isActive: [],
                navWidth:0,
                navMenuVisible:false,
                filAriane: "",
                loading: false
            };
        },
        methods:{
            logout() {
                this.$cookie.delete('jwt');
                this.$cookie.delete('role');
                this.$cookie.delete('firstName');
                this.$cookie.delete('lastName');
                this.$cookie.delete('currentAriane');
                this.$cookie.delete('historyQuery');
                this.$cookie.delete('history');
                this.$router.replace({ name: "login" });
            },
            openNav(){
                 
                if(!this.navWidth){
                    this.navWidth = 300;
                }
                else{
                    this.navWidth = 0;
                }
                
                var vm = this;
                setTimeout(function(){
                    vm.navMenuVisible = !vm.navMenuVisible;
                }, 100);
            },
            onDocumentSelected(event){
                this.files = event.target.files;
                var extension = this.files[0].name.substring(this.files[0].name.lastIndexOf(".")+1).toLowerCase();
                if(extension !== "pdf"){
                    alert("Image au mauvais format, veuillez réessayer avec un fichier PDF");
                }
                else{
                    this.loading=true;
                    this.modifyDocument();
                }                
            },
            async modifyDocument(){
                const fd = new FormData();
                fd.append('picture', this.files[0] ,this.files[0].name);
                
                var response = await axios.put('https://so.gaviota.fr/api/building/inquiry/document/'+this.files[0].name+'/'+this.$route.query.name, fd);
                
                if(response){
                    location.reload();
                }
            },
            goToCerfaTVADetail(){
                this.$cookie.set('reloaded', "false");
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "cerfatva", query:{name:this.$route.query.name}});                
            },
            goToCerfaGAZDetail(){
                this.$cookie.set('reloaded', "false");
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "cerfagaz", query:{name:this.$route.query.name}});
            },
            goToCerfaFIOULDetail(){

                this.$cookie.set('reloaded', "false");
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "cerfafioul", query:{name:this.$route.query.name}});
            },
            goToCerfaCLIMDetail(){
                this.$cookie.set('reloaded', "false");
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "cerfaclim", query:{name:this.$route.query.name}});
            },
            goToBuildingPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "buildinglist"});
            },
            goToNewBuildingPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newbuilding"});
            },
            goToPlanningPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "planningadmin"});
            },
            goToTimeSheetPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "timesheet"});
            },
            goToAllUserPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "alluser"});
            },
            goToNewUserPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newuser"});
            },
            goToAllGroupPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "allgroup"});
            },
            goToNewGroupPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newgroup"});
            },
            reload() {
                this.$cookie.set('currentAriane', "");
                this.$cookie.set('history', "");
                this.$cookie.set('historyQuery', "");
                this.$router.replace({ name: "adminhome" });
            },
            dataUrlSketch(){
                if(this.inquiry.sketch){
                    return 'data:'+this.inquiry.sketch.img.contentType+';base64,' + btoa(
                        new Uint8Array(this.inquiry.sketch.img.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                    );
                }
                else{
                    return "/assets/empty.png";
                }
            },
            dataUrl(i){
                return 'data:'+this.inquiry.picture[i].img.contentType+';base64,' + btoa(
                    new Uint8Array(this.inquiry.picture[i].img.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                );
            },
            backbtn(){

                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);
                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);
                
                this.$cookie.set('history', JSON.stringify(arrHist.slice(0, -1)));
                this.$cookie.set('historyQuery', JSON.stringify(arrQuery.slice(0, -1)));

                if(arrHist.length){
                    if(arrQuery[arrQuery.length-1] !== "" && arrQuery[arrQuery.length-1] !== "undefined"){
                        this.$router.replace({ name: arrHist[arrHist.length-1], query: {name: arrQuery[arrQuery.length-1]} });
                    }
                    else{
                        this.$router.replace({ name: arrHist[arrHist.length-1] });
                    }
                }
                else{
                    this.$cookie.set('currentAriane', "");
                    this.$router.replace({ name: "adminhome" });
                }
            },				
            getCookies: function() {
                this.filAriane = this.$cookie.get('currentAriane');
                if(!this.$cookie.get('jwt') || !this.$cookie.get('role') || (this.$cookie.get('role') !== "admin" && this.$cookie.get('role') !== "technicien bureau") || !this.$route.query.name){
                    this.logout();
                }
                else{
                    this.Name = this.$cookie.get('firstName') +" "+this.$cookie.get('lastName');
                    this.getInquiries();
                }
            },
            chageModalState(i){
                var state = !this.isActive[i];
                this.isActive.splice(i, 1);
                this.isActive.splice(i, 0,state);
            },
            async getCerfaTVA(id){
                var response = await axios.get('https://so.gaviota.fr/api/building/tva/'+id)
                if(response.data.cerfa){
                    this.cerfaTVA = response.data.cerfa;
                    if(this.cerfaTVA){
                        if(this.cerfaTVA.status === "signé" && this.cerfaTVA.signature){
                            this.sigTVA = 'data:'+this.cerfaTVA.signature.img.contentType+';base64,' + btoa(
                                new Uint8Array(this.cerfaTVA.signature.img.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                            );
                        }
                    }
                }
            },
            async getCerfaGAZ(id){
                var response = await axios.get('https://so.gaviota.fr/api/building/gaz/'+id)
                if(response.data.cerfa){
                    this.cerfaGAZ = response.data.cerfa;
                    if(this.cerfaGAZ){
                        if(this.cerfaGAZ.status === "signé" && this.cerfaGAZ.signatureTech){
                            this.sigGAZ = 'data:'+this.cerfaGAZ.signatureTech.img.contentType+';base64,' + btoa(
                                new Uint8Array(this.cerfaGAZ.signatureTech.img.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                            );
                            this.sigGAZ = 'data:'+this.cerfaGAZ.signatureCustomer.img.contentType+';base64,' + btoa(
                                new Uint8Array(this.cerfaGAZ.signatureCustomer.img.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                            );
                        }
                    }
                }
            },
            async getCerfaFIOUL(id){
                var response = await axios.get('https://so.gaviota.fr/api/building/fioul/'+id)
                if(response.data.cerfa){
                    this.cerfaFIOUL = response.data.cerfa;
                    if(this.cerfaFIOUL){
                        console.log(this.cerfaFIOUL);
                        if(this.cerfaFIOUL.status === "signé" && this.cerfaFIOUL.signatureTech){
                            this.sigFIOUL = 'data:'+this.cerfaFIOUL.signatureTech.img.contentType+';base64,' + btoa(
                                new Uint8Array(this.cerfaFIOUL.signatureTech.img.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                            );
                            this.sigFIOUL2 = 'data:'+this.cerfaFIOUL.signatureCustomer.img.contentType+';base64,' + btoa(
                                new Uint8Array(this.cerfaFIOUL.signatureCustomer.img.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                            );
                        }
                    }
                }
            },
            async getCerfaCLIM(id){
                var response = await axios.get('https://so.gaviota.fr/api/building/clim/'+id)
                if(response.data.cerfa){
                    this.cerfaCLIM = response.data.cerfa;
                    if(this.cerfaCLIM){
                        if(this.cerfaCLIM.status === "signé" && this.cerfaCLIM.signature){
                            this.sigCLIM = 'data:'+this.cerfaCLIM.signatureTech.img.contentType+';base64,' + btoa(
                                new Uint8Array(this.cerfaCLIM.signatureTech.img.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                            );
                        }
                    }
                }
            },
            async getInquiries(){
                axios.defaults.headers.common['Authorization'] = this.$cookie.get('jwt');
                var response = await axios.get('https://so.gaviota.fr/api/building/inquiry/alldocuments/'+this.$route.query.name)
                
                if(response.data.inquiry){
                    this.inquiry = response.data.inquiry;
                    for(var x=0; x<this.inquiry.document.length; x++){
                        if(this.inquiry.document[x].pdf){
                            this.pdfTitle.push(this.inquiry.document[x].name)
                            this.pdfLink.push('data:'+this.inquiry.document[x].pdf.img.contentType+';base64,' + btoa(
                                new Uint8Array(this.inquiry.document[x].pdf.img.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                            ));
                            this.isActive.push(false);
                            pdf.createLoadingTask(this.pdfLink[this.pdfLink.length-1]).then(pdf => {
                                this.numPages.push(pdf.numPages);
                            });
                        }
                    }
                    
                    if(this.inquiry.TVAsheet){
                            this.pdfTitle.push("Fiche TVA")
                            this.pdfLink.push("/assets/tva.pdf");
                            this.isActive.push(false);
                            pdf.createLoadingTask(this.pdfLink[this.pdfLink.length-1]).then(pdf => {
                                this.numPages.push(pdf.numPages);
                            });
                            this.getCerfaTVA(this.inquiry.TVAsheet._id);
                            this.indexCLIM = this.indexCLIM+1
                            this.indexGAZ = this.indexGAZ+1
                            this.indexFIOUL = this.indexFIOUL+1
                    }
                    if(this.inquiry.climsheet){
                            this.pdfTitle.push("Fiche produits dangereux")
                            this.pdfLink.push("/assets/clim.pdf");
                            this.isActive.push(false);
                            pdf.createLoadingTask(this.pdfLink[this.pdfLink.length-1]).then(pdf => {
                                this.numPages.push(pdf.numPages);
                            });
                            this.getCerfaCLIM(this.inquiry.climsheet._id);
                            this.indexGAZ = this.indexGAZ+1
                            this.indexFIOUL = this.indexFIOUL+1
                    }
                    if(this.inquiry.fioulsheet){
                            this.pdfTitle.push("Fiche entretien fioul")
                            this.pdfLink.push("/assets/fioul.PDF");
                            this.isActive.push(false);
                            pdf.createLoadingTask(this.pdfLink[this.pdfLink.length-1]).then(pdf => {
                                this.numPages.push(pdf.numPages);
                            });
                            this.getCerfaFIOUL(this.inquiry.fioulsheet._id);
                            this.indexGAZ = this.indexGAZ+1
                    }
                    if(this.inquiry.gazsheet){
                            this.pdfTitle.push("Fiche entretien gaz")
                            this.pdfLink.push("/assets/gaz.pdf");
                            this.isActive.push(false);
                            pdf.createLoadingTask(this.pdfLink[this.pdfLink.length-1]).then(pdf => {
                                this.numPages.push(pdf.numPages);
                            });
                            this.getCerfaGAZ(this.inquiry.gazsheet._id);
                    }
                }
            }
        },
        mounted(){
            this.getCookies();
        }
    }
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=BenchNine');
    #inquirydocumentsadmin {
        width: 90%;
        background-color: #FFFFFF;
        margin: auto;
        margin-top: 60px;
        margin-bottom: 30px;
        border:none;
    }
    h1{
        background-color: #1ce83e;
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        padding-bottom:15px;
        padding-top:15px;
        margin:0;
        font-size: 30px;
        font-weight: 600;
        display: block;
        text-align: center;
        position:relative;
    }
    @media screen and (max-width: 768px) {
        .h1 {
              font-size: 24px;
            }
    }
    nav{
        top:0px;
        left:0px;
        right:0px;
        margin: 0px;
        position:fixed;
        z-index:1;
        width:100%;
        background-color: white;
        border-bottom: 2px solid;
        border-color:#1ce83e;
    }
    .main{
        display: inline-block; 
        cursor: pointer;
        margin:5px;
    }

    .rightNav {
        position:absolute;
        top:0;
        right:0;
    }
    .innerNav {
        display: inline-block;
        position: relative;
    }

    .logoNav{
        vertical-align: middle;
        margin:5px;    
    }
    .navLogout{
        height: 20px;
        vertical-align: middle;
        cursor: pointer;
        margin:24px;
    }
    .leftNav{
        position:absolute;
        top:0;
        left:0;
    }   
    .pNav {
        display:inline-block;
        padding-right:15px;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        vertical-align: middle;
    }
    @media screen and (max-width: 768px) {
        .pNav {
              display: none;
            }
    }
    .homeName{
        margin:auto;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        text-align: center;
        margin:10px;
    }
    .outercircle{
        background-color: #F0F0F0;
        padding:50px;
    }
    #circle {
        width: 10px;
        height: 10px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        background: #1ce83e;
        margin:auto;
    }
    .outermargin{
        background-color: #F0F0F0;
        padding:15px;
    }
   .btnBack{
        border:none;
        cursor: pointer;
        display: inline-block;
        text-align: left;
        background-color: #1ce83e;
        font-size: 30px;
        position: absolute;
        left: 1%;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .greyBack{
        background-color: #2b2b2b;
        color:#FFFFFF;
        font-family: 'BenchNine', sans-serif;
        font-size: 24px;
        padding-top: 15px;
        padding-bottom: 30px;
        .title{
            text-align: center;
            padding:5px;
        }
        .date{
            margin-top:-10px;
            text-align: center;
            font-size: 14px;
        }
        .img{
            margin:auto;
            text-align: center;
            margin-top:20px;
            .oneImg{
                display: inline-block;
                padding:15px;
                font-size: 14px;
                span{
                    display:block;
                }
                img{
                    display:block;
                    margin:auto;
                }
            }
            .allImg{
                font-size: 14px;
                display: inline-block;
                span{
                    display:block;
                }
                img{
                    display:block;
                    margin:auto;
                }
            }

            /* The Modal (background) */
            .modalActive {
              display: block !important; /* Hidden by default */
              position: fixed; /* Stay in place */
              z-index: 1; /* Sit on top */
              padding-top: 100px; /* Location of the box */
              left: 0;
              top: 0;
              width: 100%; /* Full width */
              height: 100%; /* Full height */
              overflow: auto; /* Enable scroll if needed */
              background-color: rgb(0,0,0); /* Fallback color */
              background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
            }
            .modalInactive {
              display: none !important; /* Hidden by default */
              position: fixed; /* Stay in place */
              z-index: 1; /* Sit on top */
              padding-top: 100px; /* Location of the box */
              left: 0;
              top: 0;
              width: 100%; /* Full width */
              height: 100%; /* Full height */
              overflow: auto; /* Enable scroll if needed */
              background-color: rgb(0,0,0); /* Fallback color */
              background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
            }

            /* Modal Content (Image) */
            .modal-content {
              margin: auto;
              display: block;
              width: 80%;
              max-width: 700px;
            }

            /* Add Animation - Zoom in the Modal */
            .modal-content{ 
              animation-name: zoom;
              animation-duration: 0.6s;
            }

            @keyframes zoom {
              from {transform:scale(0)} 
              to {transform:scale(1)}
            }

            /* The Close Button */
            .close {
              position: absolute;
              top: 15px;
              right: 35px;
              color: #f1f1f1;
              font-size: 40px;
              font-weight: bold;
              transition: 0.3s;
            }

            .close:hover,
            .close:focus {
              color: #bbb;
              text-decoration: none;
              cursor: pointer;
            }

            /* 100% Image Width on Smaller Screens */
            @media only screen and (max-width: 700px){
              .modal-content {
                width: 100%;
              }
            }
        }
    }
    .filAriane{
        background-color: #F0F0F0;
        font-family: 'BenchNine', sans-serif;
        padding-top:20px;
        margin-left:-50px;
        margin-bottom:-17px;
        font-size: 17px;
    }
    .sideNav{
        background-clip: border-box;
        background-color: #FFF;
        background-origin: padding-box;
        box-sizing: border-box;
        background-color: #333;
        display: block;
        height: 100%;
        overflow:auto;
        box-shadow: 8px 0px 6px -6px #999;
        position:fixed;
        top:0;
        left:0;
        z-index:10;
        -webkit-transition: width 0.5s;
        transition: width 0.5s;
    }
    .navsidecontent{
        color:white;
        font-family: 'BenchNine', sans-serif;
        margin-top:65px;
        margin-left:30px;
        margin-right:30px;
        -webkit-transition: width 0.5s;
        transition: width 0.5s;
    }
    .navtitle{
        margin:10px;
        margin-top:15px;
        padding-top:5px;
        font-size: 24px;
        font-weight: 700;
        text-align: center;
        border-top: 1px solid;
        border-color:#eee;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor:default;
                              
    }
    .navsubtitle{
        margin:7px;
        font-size: 18px;
        font-weight: 400;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor:pointer;
    }
    .navsubtitle:hover{
        color:#999;
    }
    .noborder{
        border:none;
        margin-top:5px;
        padding-top:0px;
    }
    .logout{
        padding-top:50px;
        cursor:pointer;
    }
    
	/* width */
	::-webkit-scrollbar {
		width: 6px;
	}
	
	/* Track */
	::-webkit-scrollbar-track {
		background: #ddd; 
	}
	
	/* Handle */
	::-webkit-scrollbar-thumb {
		background: #888; 
		border-radius: 3px;
	}
	
	/* Handle on hover */
	::-webkit-scrollbar-thumb:hover {
		background: #555; 
	}
    .btnNewBtn{
        width:25px;
        height: 25px;
        border-radius: 50%;
        font-stretch: ultra-condensed;
        font-size: 15px;
        border:none;
        color:black;
        cursor: pointer;
        background-color: #1ce83e;
        display:inline-block;
        position: absolute;
        right: 18px;
        top: 18px;
    }
    
    .divCard{
        vertical-align: middle;
        position: relative;
        padding-left: 15px;
        padding-bottom: 25px;
    }

    #loading {
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        position: fixed;
        opacity: 0.7;
        background-color: #fff;
        z-index: 99;
        text-align: center;
    }
    #loading-image {
         position: absolute;
         top: 100px;
         left: 240px;
         z-index: 100;
    }
    .dlBtn{
        color:white;
        font-size: 20px;
        padding-bottom: 10px;
        margin-bottom: 10px;
    }


.pdfcontainer {
    width: 800px;
    margin: auto;
    position: relative;
    .fix-focus:focus {
        outline: none;
    }
    .date-picker::-webkit-calendar-picker-indicator {
        opacity: 1;
    }
    .date-picker::-webkit-clear-button,
    .date-picker::-webkit-inner-spin-button {
        display: none;
        -webkit-appearance: none;
    }
    .nameOverPdf {
        position: absolute;
        top: 43px;
        left: 210px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .customerFirstname {
        position: absolute;
        top: 80px;
        right: 418px;

        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .customerStreetName {
        position: absolute;
        top: 117px;
        left: 237px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .companyName {
        position: absolute;
        top: 45px;
        right: 25px;
        width: 180px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .companyPhone {
        position: absolute;
        top: 100px;
        right: 232px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .companyAdress {
        position: absolute;
        top: 118px;
        right: 200px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .waterHeaterBrand {
        position: absolute;
        top: 211px;
        left: 150px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .waterHeaterPower {
        position: absolute;
        top: 230px;
        left: 257px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .waterHeaterEvacuationType {
        position: absolute;
        top: 248px;
        left: 190px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .waterHeaterPutIntoUse {
        position: absolute;
        top: 266px;
        left: 190px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .waterHeaterSerialNumber {
        position: absolute;
        top: 285px;
        left: 155px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .burnerBrand {
        position: absolute;
        top: 210px;
        right: 80px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .burnerPower {
        position: absolute;
        top: 230px;
        right: 24px;
        width: 100px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .burnerEvacuationType {
        position: absolute;
        top: 248px;
        right: 84px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .burnerPutIntoUse {
        position: absolute;
        top: 266px;
        right: 36px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .burnerSerialNumber {
        position: absolute;
        top: 285px;
        right: 79px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .lastIntervention {
        position: absolute;
        top: 307px;
        left: 276px;
        width: 106px;
        font-size: 14px;
        border: 0px solid;
    }
    .lastCleaningIntervention {
        position: absolute;
        top: 306px;
        right: 50px;
        width: 106px !important;
        font-size: 14px;
        border: 0px solid;
    }
    .deviceConnectionOk {
        position: absolute;
        top: 377px;
        right: 118px;
        font-size: 14px;
        background-color: transparent;
    }
    .deviceConnectionNOT {
        position: absolute;
        top: 377px;
        right: 50px;
        font-size: 14px;
        background-color: transparent;
    }
    .burnerCorsCleaningOK {
        position: absolute;
        top: 404px;
        right: 118px;
        font-size: 14px;
        background-color: transparent;
    }
    .burnerCorsCleaningNOT {
        position: absolute;
        top: 404px;
        right: 50px;
        font-size: 14px;
        background-color: transparent;
    }

    .burnerCleaningOk {
        position: absolute;
        top: 423px;
        right: 118px;
        font-size: 14px;
        background-color: transparent;
    }
    .burnerCleaningNOT {
        position: absolute;
        top: 423px;
        right: 50px;
        font-size: 14px;
        background-color: transparent;
    }
    .preFilterFioulCleaningOk {
        position: absolute;
        top: 442px;
        right: 118px;
        font-size: 14px;
        background-color: transparent;
    }
    .preFilterFioulCleaningNOT {
        position: absolute;
        top: 442px;
        right: 50px;
        font-size: 14px;
        background-color: transparent;
    }
    .preFilterFioulCleaningOther {
        position: absolute;
        top: 442px;
        right: 197px;
        font-size: 14px;
        background-color: transparent;
    }
    .fioulFilterCleaningOk {
        position: absolute;
        top: 461px;
        right: 118px;
        font-size: 14px;
        background-color: transparent;
    }
    .fioulFilterCleaningNOT {
        position: absolute;
        top: 461px;
        right: 50px;
        font-size: 14px;
        background-color: transparent;
    }
    .fioulFilterCleaningOk {
        position: absolute;
        top: 461px;
        right: 118px;
        font-size: 14px;
        background-color: transparent;
    }
    .fioulFilterCleaningNOT {
        position: absolute;
        top: 461px;
        right: 50px;
        font-size: 14px;
        background-color: transparent;
    }
    .deviceSecurityCheckOk {
        position: absolute;
        top: 480px;
        right: 118px;
        font-size: 14px;
        background-color: transparent;
    }
    .deviceSecurityCheckNOT {
        position: absolute;
        top: 480px;
        right: 50px;
        font-size: 14px;
        background-color: transparent;
    }
    .devicHeatingCirculatorCheckOk {
        position: absolute;
        top: 499px;
        right: 118px;
        font-size: 14px;
        background-color: transparent;
    }
    .devicHeatingCirculatorCheckNOT {
        position: absolute;
        top: 499px;
        right: 50px;
        font-size: 14px;
        background-color: transparent;
    }
    .devicHeatingCirculatorCheckOther {
        position: absolute;
        top: 499px;
        right: 197px;
        font-size: 14px;
        background-color: transparent;
    }
    .deviceRegilationComponentsCheckOk {
        position: absolute;
        top: 541px;
        right: 118px;
        font-size: 14px;
        background-color: transparent;
    }
    .deviceRegilationComponentsCheckNOT {
        position: absolute;
        top: 541px;
        right: 50px;
        font-size: 14px;
        background-color: transparent;
    }
    .deviceRegilationComponentsCheckOther {
        position: absolute;
        top: 541px;
        right: 197px;
        font-size: 14px;
        background-color: transparent;
    }
    .deviceHydrauliquePressureCheckOk {
        position: absolute;
        top: 560px;
        right: 118px;
        font-size: 14px;
        background-color: transparent;
    }
    .deviceHydrauliquePressureCheckNOT {
        position: absolute;
        top: 560px;
        right: 50px;
        font-size: 14px;
        background-color: transparent;
    }
    .deviceAnodeAndAccessoriesCheckOk {
        position: absolute;
        top: 587px;
        right: 118px;
        font-size: 14px;
        background-color: transparent;
    }
    .deviceAnodeAndAccessoriesCheckNOT {
        position: absolute;
        top: 587px;
        right: 50px;
        font-size: 14px;
        background-color: transparent;
    }
    .deviceAnodeAndAccessoriesCheckOther {
        position: absolute;
        top: 587px;
        right: 197px;
        font-size: 14px;
        background-color: transparent;
    }
    .otherCheckedPoints {
        position: absolute;
        top: 620px;
        left: 170px;
        width: 600px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
        resize: none;
        overflow: hidden;
    }
    .bacharachTest {
        position: absolute;
        top: 685px;
        left: 330px;
        width: 100px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .smokeTemperature {
        position: absolute;
        top: 707px;
        left: 215px;
        width: 40px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .ambianteTemperature {
        position: absolute;
        top: 707px;
        right: 230px;
        width: 40px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .smokeContent {
        position: absolute;
        top: 725px;
        right: 260px;
        width: 100px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .pressure {
        position: absolute;
        top: 750px;
        left: 275px;
        width: 100px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .contentCO {
        position: absolute;
        top: 773px;
        right: 65px;
        width: 50px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .contentCOPercentageOk {
        position: absolute;
        top: 800px;
        left: 84px;
        font-size: 14px;
        background-color: transparent;
    }
    .contentCOPercentageNOT {
        position: absolute;
        top: 839px;
        left: 84px;
        font-size: 14px;
        background-color: transparent;
    }
    .contentCOPercentageDanger {
        position: absolute;
        top: 886px;
        left: 84px;
        font-size: 14px;
        background-color: transparent;
    }
    .mesurementDevice {
        position: absolute;
        top: 949px;
        left: 45px;
        width: 700px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .mesuredPerformance {
        position: absolute;
        top: 1033px;
        left: 313px;
        width: 25px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .referencedPerformance {
        position: absolute;
        top: 1073px;
        left: 313px;
        width: 25px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .NOxEmission {
        position: absolute;
        top: 1033px;
        right: 45px;
        width: 40px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .correctedDefect {
        position: absolute;
        top: 1380px;
        left: 33px;
        width: 725px;
        font-size: 14px;
        background-color: transparent;
        // border: 0px solid;
        resize: none;
        overflow: hidden;
    }
    .usageRecommendation {
        position: absolute;
        top: 1530px;
        left: 33px;
        width: 725px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
        resize: none;
        overflow: hidden;
    }
    .upgradeRecommendation {
        position: absolute;
        top: 1710px;
        left: 33px;
        width: 725px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
        resize: none;
        overflow: hidden;
    }
    .futureRecommendation {
        position: absolute;
        top: 1900px;
        left: 33px;
        width: 725px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
        resize: none;
        overflow: hidden;
    }
    .signatureTimestamp {
        position: absolute;
        top: 2100px;
        left: 387px;
        width: 150px;
        font-size: 14px;
        border: 0px solid;
    }
    .imgOverPdf2 {
        position: absolute;
        bottom: 80px;
        left: 200px;
        width: 128px;
        height: 48px;
    }
    .accept {
        margin-bottom: 20px;
        input[type="checkbox"] {
            display: none;
        }
        input[type="checkbox"] + label {
            display: block;
            position: relative;
            padding-left: 35px;
            margin-bottom: 20px;
            font-size: 0.9rem;
            cursor: pointer;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
        }
        input[type="checkbox"] + label:last-child {
            margin-bottom: 0;
        }
        input[type="checkbox"] + label:before {
            content: "";
            display: block;
            width: 8px;
            height: 8px;
            // border: 2px solid black;
            position: absolute;
            left: 6px;
            top: 6px;
            -webkit-transition: all 0.12s, border-color 0.08s;
            transition: all 0.12s, border-color 0.08s;
        }
        input[type="checkbox"]:checked + label:before {
            width: 10px;
            top: 0px;
            left: 5px;
            border-radius: 0;
            border: 2px solid black;

            opacity: 1;
            border-top-color: transparent;
            border-left-color: transparent;
            -webkit-transform: rotate(45deg);
            transform: rotate(45deg);
        }
    }
}
</style>